<article class="invoice-container">
  <section>
    <h1>{{title}}: {{fullName}}</h1>
  </section>
  <section class="categoryField">
    <p>{{message}}</p>
    <p>{{expenseCategory.amount | customCurrency}}</p>
    <p>{{expenseCategory.category | titlecase}}</p>
  </section>

  <section class="single-upload-container">
    <app-upload-files
      fieldLabel="{{expenseCategory.category}}"
      (fileEmitter)="addFile($event)"
    ></app-upload-files>
  </section>
  <section class="buttons">
    <button mat-flat-button color="accent" (click)="Cancel()">Cancel</button>
    <button
      mat-flat-button color="primary"
      [disabled]="!file"
      (click)=" addInvoice()"
    >
       {{ getButtonLabel()}}
    </button>
  </section>
</article>
